import React from 'react'
import { Link } from 'react-router-dom'

const Additional = () => {
  return (
    <div>
        
        {/* Search Form Start */}
        <div className="mb-5 wow slideInUp" data-wow-delay="0.1s">
          <div className="input-group">
            <input type="text" className="form-control p-3" placeholder="Keyword" />
            <button className="btn btn-primary px-4"><i className="bi bi-search" /></button>
          </div>
        </div>
        {/* Search Form End */}
        {/* Category Start */}
        <div className="mb-5 wow slideInUp" data-wow-delay="0.1s">
          <div className="section-title section-title-sm position-relative pb-3 mb-4">
            <h3 className="mb-0">Related Courses</h3>
          </div>
          <div className="link-animated d-flex flex-column justify-content-start">
            <Link className="h5 fw-semi-bold bg-light rounded py-2 px-3 mb-2" to="/frontend"><i className="bi bi-arrow-right me-2" />Frontend Developer</Link>
            <Link className="h5 fw-semi-bold bg-light rounded py-2 px-3 mb-2" to="/corejava"><i className="bi bi-arrow-right me-2" />Core Java</Link>
            <Link className="h5 fw-semi-bold bg-light rounded py-2 px-3 mb-2" to="/javafullstack"><i className="bi bi-arrow-right me-2" />Full Stack Developer</Link>
            <Link className="h5 fw-semi-bold bg-light rounded py-2 px-3 mb-2" to="/python"><i className="bi bi-arrow-right me-2" />Python</Link>
            <Link className="h5 fw-semi-bold bg-light rounded py-2 px-3 mb-2" to="/digitalmarketing"><i className="bi bi-arrow-right me-2" />Digital Marketing</Link>
          </div>
        </div>
        {/* Category End */}
        {/* Recent Post Start */}
        <div className="mb-5 wow slideInUp" data-wow-delay="0.1s">
          <div className="section-title section-title-sm position-relative pb-3 mb-4">
            <h3 className="mb-0">Recent Post</h3>
          </div>
          <div className="d-flex rounded overflow-hidden mb-3">
            <img className="img-fluid" src="assets/img/blog-1.jpg" style={{width: 100, height: 100, objectFit: 'cover'}}  />
            <a href className="h5 fw-semi-bold d-flex align-items-center bg-light px-3 mb-0">UpComing Jobs
            </a>
          </div>
        </div>
        {/* Recent Post End */}
        {/* Image Start */}
        <div className="mb-5 wow slideInUp" data-wow-delay="0.1s">
          <img src="assets/img/blog-1.jpg"  className="img-fluid rounded" />
        </div>
        {/* Image End */}
        {/* Tags Start */}
        {/*   <div class="mb-5 wow slideInUp" data-wow-delay="0.1s">
                  <div class="section-title section-title-sm position-relative pb-3 mb-4">
                      <h3 class="mb-0">Tag Cloud</h3>
                  </div>
                  <div class="d-flex flex-wrap m-n1">
                      <a href="" class="btn btn-light m-1">Design</a>
                      <a href="" class="btn btn-light m-1">Development</a>
                      <a href="" class="btn btn-light m-1">Marketing</a>
                      <a href="" class="btn btn-light m-1">SEO</a>
                      <a href="" class="btn btn-light m-1">Writing</a>
                      <a href="" class="btn btn-light m-1">Consulting</a>
                      <a href="" class="btn btn-light m-1">Design</a>
                      <a href="" class="btn btn-light m-1">Development</a>
                      <a href="" class="btn btn-light m-1">Marketing</a>
                      <a href="" class="btn btn-light m-1">SEO</a>
                      <a href="" class="btn btn-light m-1">Writing</a>
                      <a href="" class="btn btn-light m-1">Consulting</a>
                  </div>
              </div> */}
        {/* Tags End */}
        {/* Plain Text Start */}
        <div className="wow slideInUp" data-wow-delay="0.1s">
          <div className="section-title section-title-sm position-relative pb-3 mb-4">
            <h3 className="mb-0">Do</h3>
          </div>
          <div className="bg-light text-center" style={{padding: 30}}>
            <p>Full Stack Developer courses with 100% Placement Assistance</p>
            <a href className="btn btn-primary py-2 px-4">Read More</a>
          </div>
        </div>
        {/* Plain Text End */}
     
    </div>
  )
}

export default Additional